import { render } from "./AllFaqs.vue?vue&type=template&id=1b0878f2"
import script from "./AllFaqs.vue?vue&type=script&lang=js"
export * from "./AllFaqs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__